<template>
  <!-- Gedeelde footer voor de landingspagina en de info-content pagina's. -->
  <footer class="border-t border-[var(--color-mode-border)] px-5 py-8 md:px-8">
    <div
      class="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 text-sm text-neutral-500 md:flex-row"
    >
      <div>
        © {{ year }} CAOBOT · een product van
        <a
          href="https://www.violet88.nl/"
          target="_blank"
          rel="noopener noreferrer"
          class="underline underline-offset-2 transition hover:text-[var(--color-mode-text)]"
          >Violet88</a
        >
      </div>
      <ul class="flex gap-6">
        <li>
          <NuxtLink
            to="/info/algemene-voorwaarden"
            class="transition hover:text-[var(--color-mode-text)]"
            >Algemene voorwaarden</NuxtLink
          >
        </li>
        <li>
          <NuxtLink
            to="/info/privacy"
            class="transition hover:text-[var(--color-mode-text)]"
            >Privacybeleid</NuxtLink
          >
        </li>
        <li>
          <NuxtLink
            to="/info/faq"
            class="transition hover:text-[var(--color-mode-text)]"
            >FAQ</NuxtLink
          >
        </li>
      </ul>
    </div>
  </footer>
</template>

<script setup lang="ts">
const year = new Date().getFullYear();
</script>
